import {
  FILTER_KEY_AD_GROUP1,
  FILTER_KEY_AD_GROUP2,
  FILTER_KEY_ADEBIFY_AD_PRODUCT_CATEGORY,
  FILTER_KEY_ADEBIFY_AD_PRODUCT_NAME,
  FILTER_KEY_ADEBIFY_PRODUCT_CATEGORY,
  FILTER_KEY_ADEBIFY_PURCHASED_PRODUCT,
  FILTER_KEY_CHANNEL_DISPLAY,
  FILTER_KEY_MEDIA,
  FILTER_KEY_MEDIA_ACCOUNT,
  FILTER_KEY_MEDIA_SIDE_CAMPAIGN,
  FILTER_KEY_MEDIA_SIDE_GROUP,
  FILTER_OPERATOR_EXACT,
} from 'services/consts';

// Translation between Redjug's global filter keys and the snake_case API keys
// expected by jug-api (Adebify). Used by Product Analysis, LTV Detail and the
// cohort screen — see the matching `Adebify*FilterContainer` helpers and
// adebify/docs/要件.md §456-480 (付録E).
export const ADEBIFY_FILTER_KEY_MAP = {
  [FILTER_KEY_CHANNEL_DISPLAY]: 'channel_type',
  [FILTER_KEY_MEDIA_ACCOUNT]: 'media',
  [FILTER_KEY_MEDIA_SIDE_CAMPAIGN]: 'media_campaign',
  [FILTER_KEY_MEDIA_SIDE_GROUP]: 'media_ad_group',
  [FILTER_KEY_MEDIA]: 'media_type',
  [FILTER_KEY_AD_GROUP1]: 'ad_group1',
  [FILTER_KEY_AD_GROUP2]: 'ad_group2',
  [FILTER_KEY_ADEBIFY_PRODUCT_CATEGORY]: 'product_category',
  [FILTER_KEY_ADEBIFY_PURCHASED_PRODUCT]: 'purchased_product',
  [FILTER_KEY_ADEBIFY_AD_PRODUCT_CATEGORY]: 'ad_product_category',
  [FILTER_KEY_ADEBIFY_AD_PRODUCT_NAME]: 'ad_product_name',
};

// Cohort filters target the customer's first-purchase context (F1) so the API
// expects each key prefixed with `f1_`. See 要件.md §476-480 (付録E-3).
export const ADEBIFY_LTV_COHORT_FILTER_KEY_MAP = Object.fromEntries(
  Object.entries(ADEBIFY_FILTER_KEY_MAP).map(([key, apiKey]) => [
    key,
    `f1_${apiKey}`,
  ])
);

const getSelectedFilterValues = (filterKey, filter) => {
  // Type-1/3/4 master filters store display names in `values` and IDs in `ids`
  // (see FilterService). Type-2 text filters only use `values`.
  const values =
    filter.type === 2
      ? filter.values || filter.ids
      : filter.ids || filter.values;

  if (!Array.isArray(values)) {
    return values ? [values] : [];
  }

  return values.filter(
    (value) => value !== null && value !== undefined && value !== ''
  );
};

const normalizeAdebifyFilter = (filterKey, filter) => {
  const values = getSelectedFilterValues(filterKey, filter);
  if (values.length === 0) return null;

  // Type 2 filters are free-text match filters. Preserve their matching
  // operator so the API can distinguish "contains" from exact matching.
  if (filter.type === 2) {
    return {
      values,
      operator: filter.option || FILTER_OPERATOR_EXACT,
    };
  }

  return values;
};

// Map raw Redjug filter store entries to the snake_case structure the Adebify
// API expects. `keyMap` defaults to the standard map, but cohort screens pass
// `ADEBIFY_LTV_COHORT_FILTER_KEY_MAP` to emit `f1_*` keys instead.
export const mapAdebifyFilters = (filters, keyMap = ADEBIFY_FILTER_KEY_MAP) =>
  Object.keys(filters).reduce((acc, filterKey) => {
    const apiKey = keyMap[filterKey];
    if (!apiKey) return acc;

    const filterValue = normalizeAdebifyFilter(filterKey, filters[filterKey]);
    if (!filterValue) return acc;

    return {
      ...acc,
      [apiKey]: filterValue,
    };
  }, {});
